import { type PackagingUoms } from "./types/packaging"

import {
  CompanyDefaultUnitOfMeasurement,
  FieldGroupEnum,
  ProductFormInfoItem,
  ProductStockType,
} from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const ProductFileTypeToLabel: Partial<Record<FieldGroupEnum, string>> = {
  [FieldGroupEnum.ProductCoa]: "COA",
  [FieldGroupEnum.ProductCoo]: "COO",
  [FieldGroupEnum.ProductLabwork]: "Labwork",
  [FieldGroupEnum.Miscellaneous]: "Miscellaneous",
  [FieldGroupEnum.ProductSds]: "SDS",
  [FieldGroupEnum.ProductTds]: "TDS",
}

export const INCH_UOM_ID = "USSTD_DISTANCE_INCH"

export const UOM_PAIRS: { value: PackagingUoms; label: string; id: string }[] = [
  {
    value: {
      us: CompanyDefaultUnitOfMeasurement.UsstdWeightPound,
      metric: CompanyDefaultUnitOfMeasurement.MetricWeightKilogram,
    },
    label: "Pound (lb) / Kilogram (kg)",
  },
  {
    value: {
      us: CompanyDefaultUnitOfMeasurement.UsstdWeightShortTon,
      metric: CompanyDefaultUnitOfMeasurement.MetricWeightTon,
    },
    label: "Short Ton (st) / Metric Ton (mt)",
  },
  {
    value: {
      us: "USSTD_VOLUME_GALLON",
      metric: "METRIC_VOLUME_LITER",
    },
    label: "Gallon (gal) / Liter (l)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_CASE",
      metric: "METRIC_WEIGHT_CASE",
    },
    label: "Cases (cs)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_EACH",
      metric: "METRIC_WEIGHT_EACH",
    },
    label: "Each (ea)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_ROLL",
      metric: "METRIC_WEIGHT_ROLL",
    },
    label: "Rolls (rol)",
  },
].map(({ value, label }) => ({ value, label, id: [value.us, value.metric].join("-") }))

export const STOCK_TYPE_TO_LABEL: Record<ProductStockType, string> = {
  [ProductStockType.StockItem]: "Stock",
  [ProductStockType.NonStockItem]: "Non Stock",
  [ProductStockType.MadeToOrder]: "Made to Order",
}

export const STOCK_TYPE_OPTIONS: Option<ProductStockType>[] = [
  { value: ProductStockType.StockItem, label: STOCK_TYPE_TO_LABEL[ProductStockType.StockItem] },
  { value: ProductStockType.NonStockItem, label: STOCK_TYPE_TO_LABEL[ProductStockType.NonStockItem] },
  { value: ProductStockType.MadeToOrder, label: STOCK_TYPE_TO_LABEL[ProductStockType.MadeToOrder] },
]

export const PRODUCT_FORM_INFO_ITEM_TO_LABEL: Record<ProductFormInfoItem, string> = {
  [ProductFormInfoItem.Bead]: "Bead",
  [ProductFormInfoItem.Diced]: "Diced",
  [ProductFormInfoItem.Flake]: "Flake",
  [ProductFormInfoItem.Granule]: "Granule",
  [ProductFormInfoItem.Liquid]: "Liquid",
  [ProductFormInfoItem.LiquidDispersion]: "Liquid Dispersion",
  [ProductFormInfoItem.Pellet]: "Pellet",
  [ProductFormInfoItem.Powder]: "Powder",
  [ProductFormInfoItem.Slab]: "Slab",
}
